import React from 'react';

import { withMediaQueries } from '../../hoc/withMediaQueries';
import { TypographyTypes } from '../../themes/_declarations/typography';
import { FontStyle } from './styles';
import { FontProps } from './types';

const getFontTag = (type: TypographyTypes) =>
  ({
    bodyBold: 'p',
    bodyInteractive: 'a',
    bodyLBold: 'p',
    bodyLRegular: 'p',
    bodyRegular: 'p',
    bodySBold: 'p',
    bodySDiscount: 'p',
    bodySInteractive: 'a',
    bodySRegular: 'p',
    bodyXSRegular: 'p',
    breadcrumbRegular: 'a',
    breadcrumbUnderlined: 'a',
    heading1: 'h1',
    heading2: 'h2',
    heading2Functional: 'h2',
    heading2Impact: 'h2',
    heading3: 'h3',
    heading4: 'h4',
    heading5: 'h5',
    heading6: 'h6',
    heading7: 'p',
    heading8: 'p',
    initials: 'span',
    initialsSmall: 'span',
    priceMedium: 'span',
    priceSmall: 'span',
    textLinkRegular: 'a',
    textLinkUnderlined: 'a'
  })[type];

const Font: React.FC<FontProps> = React.memo(
  ({
    $mediaIsPhone,
    children,
    customConfiguration,
    customTag,
    ellipsis = false,
    inline = false,
    inlineBlock = false,
    ref,
    variant = 'bodyRegular',
    ...otherProps
  }) => {
    const fontTag = customTag || getFontTag(variant || 'bodyLRegular');
    return (
      <FontStyle
        $customConfiguration={customConfiguration}
        $device={$mediaIsPhone ? 'mobile' : 'desktop'}
        $ellipsis={ellipsis}
        $inline={inline}
        $inlineBlock={inlineBlock}
        $type={variant}
        as={fontTag}
        ref={ref}
        {...otherProps}
      >
        {children}
      </FontStyle>
    );
  }
);

export default withMediaQueries(Font);
